/* =========================================================================
   My Prolearning — Search results page
   Scroll reveal, scroll-progress bar, back-to-top, sticky toolbar, smart
   search field (clear button, "/" shortcut), sort auto-submit, animated
   result count, and query highlighting.
   Add-to-cart is handled globally by mpl-chrome.js (.mpl-add-form forms).
   ========================================================================= */
(function () {
  "use strict";
  var root = document.querySelector(".mpl-search");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- search field: clear button + state ---------- */
  var field = root.querySelector(".search-field");
  var input = root.querySelector(".search-input");
  var clear = root.querySelector(".search-clear");
  function syncField() { if (field && input) field.classList.toggle("has-value", !!input.value.trim()); }
  if (input) { input.addEventListener("input", syncField); syncField(); }
  if (clear && input) clear.addEventListener("click", function () {
    input.value = ""; syncField(); input.focus();
  });
  /* "/" focuses the search field (unless already typing) */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target, tag = t && t.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || (t && t.isContentEditable)) return;
    if (input) { e.preventDefault(); input.focus(); input.select(); }
  });

  /* ---------- sort: auto-submit ---------- */
  var sortSel = root.querySelector(".sort-select");
  if (sortSel) sortSel.addEventListener("change", function () {
    var f = sortSel.closest("form"); if (f) f.submit();
  });

  /* ---------- query highlight in result titles ---------- */
  (function () {
    var q = (root.getAttribute("data-terms") || "").trim();
    if (!q) return;
    var words = q.split(/\s+/).filter(function (w) { return w.length >= 2; })
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); });
    if (!words.length) return;
    var re = new RegExp("(" + words.join("|") + ")", "gi");
    var targets = root.querySelectorAll(".pcard-title a, .rcard-link h3");
    [].forEach.call(targets, function (el) {
      if (el.querySelector("mark")) return;
      var txt = el.textContent;
      if (re.test(txt)) { re.lastIndex = 0; el.innerHTML = txt.replace(re, '<mark class="hl">$1</mark>'); }
    });
  })();

  /* ---------- animated result count ---------- */
  var countEl = root.querySelector("[data-count]");
  if (countEl && !reduce) {
    var to = parseInt(countEl.getAttribute("data-count"), 10) || 0;
    var start = performance.now();
    (function tick(now) {
      var p = Math.min(1, (now - start) / 900), e = 1 - Math.pow(1 - p, 3);
      countEl.textContent = Math.round(to * e);
      if (p < 1) requestAnimationFrame(tick);
    })(start);
  }

  /* ---------- scroll progress · back-to-top · sticky toolbar ---------- */
  var bar = root.querySelector(".scrollbar");
  var totop = root.querySelector(".totop");
  var toolbar = root.querySelector(".search-toolbar");
  var toolbarTop = toolbar ? toolbar.getBoundingClientRect().top + window.scrollY : 0;
  function onScroll() {
    var y = window.scrollY || 0;
    if (bar) { var h = document.documentElement.scrollHeight - window.innerHeight; bar.style.width = (h > 0 ? (y / h * 100) : 0) + "%"; }
    if (totop) totop.classList.toggle("show", y > 700);
    if (toolbar) toolbar.classList.toggle("stuck", y > toolbarTop);
  }
  window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  if (totop) totop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" }); });

  /* ---------- header shadow on scroll (parity with other pages) ---------- */
  var hdr = document.querySelector("header.site, .mpl-header");
  if (hdr) window.addEventListener("scroll", function () { hdr.classList.toggle("scrolled", (window.scrollY || 0) > 10); }, { passive: true });

  /* ---------- scroll reveal (cards stagger) ---------- */
  var els = root.querySelectorAll(
    ".collection-eyebrow, h1.collection-title, .collection-desc, .search-form, .dchips, .collection-meta, .pcard, .rcard-link, .banner"
  );
  if (reduce || !("IntersectionObserver" in window)) {
    [].forEach.call(els, function (e) { e.classList.add("in"); });
    return;
  }
  [].forEach.call(els, function (e) { e.classList.add("reveal"); });
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      var sibs = [].slice.call(en.target.parentElement.children)
        .filter(function (c) { return c.classList.contains("reveal"); });
      en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 55) + "ms";
      en.target.classList.add("in");
      io.unobserve(en.target);
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -7% 0px" });
  [].forEach.call(els, function (e) { io.observe(e); });
})();
